import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CalculateIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 68 68">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M0 0H68V68H0z"
            transform="translate(-705 -2278) translate(705 2278)"
          />
          <path
            fill="#EDC14F"
            fillRule="nonzero"
            d="M53.833 8.5H14.167C11.05 8.5 8.5 11.05 8.5 14.167v39.666c0 3.117 2.55 5.667 5.667 5.667h39.666c3.117 0 5.667-2.55 5.667-5.667V14.167c0-3.117-2.55-5.667-5.667-5.667zM36.918 20.003L39.922 17l3.995 3.995L47.912 17l3.003 3.003-3.995 3.995 3.995 3.995-3.003 3.004-3.995-3.967-3.995 3.995-3.004-3.003 3.995-3.995-3.995-4.024zm-19.21 1.87h14.167v4.25H17.708v-4.25zm14.875 23.46h-5.666V51h-4.25v-5.667H17v-4.25h5.667v-5.666h4.25v5.666h5.666v4.25zM51 48.875H36.833v-4.25H51v4.25zm0-7.083H36.833v-4.25H51v4.25z"
            transform="translate(-705 -2278) translate(705 2278)"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default CalculateIcon;
